var map = {
	"./circle.png": 90156,
	"./diamond.png": 77618,
	"./ellipse.png": 76932,
	"./image.png": 22473,
	"./rect.png": 68130,
	"./star.png": 89732,
	"./triangle.png": 64040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46627;